import React, { createContext, useContext, useState, ReactNode } from "react";

interface User {
  username: string;
  name: string;
  role: string;
}

interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  login: (username: string, password: string) => boolean;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [user, setUser] = useState<User | null>(() => {
    if (typeof window !== "undefined") {
      const stored = localStorage.getItem("prp2pop_user");
      return stored ? JSON.parse(stored) : null;
    }
    return null;
  });

  const login = (username: string, password: string): boolean => {
    // Dummy authentication - admin/admin
    if (username === "admin" && password === "admin") {
      const userData: User = {
        username: "admin",
        name: "Administrator",
        role: "Admin",
      };
      setUser(userData);
      if (typeof window !== "undefined") {
        localStorage.setItem("prp2pop_user", JSON.stringify(userData));
      }
      return true;
    }
    return false;
  };

  const logout = () => {
    setUser(null);
    if (typeof window !== "undefined") {
      localStorage.removeItem("prp2pop_user");
    }
  };

  return (
    <AuthContext.Provider value={{ user, isAuthenticated: !!user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
